import React, { useState } from "react";
import axios from "axios";
import "./login.scss";
import logo from "../../assets/spizop-logo.png";
import { useNavigate } from "react-router-dom";
import eyeIconCross from "../../assets/eye_icon_cross.png";
import eyeIcon from "../../assets/eye_icon.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(
        "https://spizopapi.fitoja.in/api/login-admin-panel",
        { email, password }
      );
      const { token } = response.data;
      localStorage.setItem("email", email);
      localStorage.setItem("token", token);
      navigate("/dashboard");
    } catch (err) {
      setError("Invalid email or password");
      console.error("Login failed:", err);
    }
  };

  return (
    <div className="new-login-container">
      <div className="new-login-card">
        <header className="login-header">
          <img src={logo} alt="Spizop Logo" className="new-login-logo" />
          <div className="brand-text">
            <span className="welcome-sub">Welcome to</span>
            <span className="welcome-main">Spizop CRM</span>
          </div>
        </header>

        {error && <p className="new-error-message">{error}</p>}

        <form onSubmit={handleSubmit} className="new-login-form">
          <div className="new-input-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="new-login-input"
            />
          </div>

          <div className="new-input-group password-group">
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="new-login-input"
              />
              <button
                type="button"
                className="new-eye-icon-btn"
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <img
                  className="new-eye-icon-img"
                  src={showPassword ? eyeIconCross : eyeIcon}
                  alt="Toggle Visibility"
                />
              </button>
            </div>
          </div>

          <button type="submit" className="new-login-btn">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
